(function () {
  if (typeof gtag === 'undefined') return;

  /* Only events the Google & YouTube app doesn't send. The app already sends
     page_view, view_item, add_to_cart, begin_checkout and purchase, so firing
     them here as well double-counted them (see the GA4 note in theme.liquid). */

  /* Cart-drawer upsell funnel (view_item_list -> select_item -> upsell_add_to_cart).
     The cards are injected into the drawer by global.js, so we rely on a
     MutationObserver + delegated listeners rather than inline script. */
  var UPSELL_LIST = { id: 'cart_drawer_upsell', name: 'Cart drawer upsell' };
  var pendingUpsellVariant = null;

  /* ─── view_item_list ─────────────────────────────────────
     Fires on collection/search pages. Data injected by
     sections/main-collection-product-grid.liquid via
     window.ga4ListData.
  ─────────────────────────────────────────────────────────*/
  function trackViewItemList() {
    var d = window.ga4ListData;
    if (!d) return;
    gtag('event', 'view_item_list', {
      item_list_id: d.list_id,
      item_list_name: d.list_name,
      items: d.items,
    });
  }

  /* ─── select_item ────────────────────────────────────────
     Fires when a user clicks a product card link.
     Reads data-ga4-* attributes added to <card-product>.
  ─────────────────────────────────────────────────────────*/
  function initSelectItem() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href*="/products/"]');
      if (!link) return;
      var card = link.closest('[data-ga4-product-id]');
      if (!card) return;
      // Cart-drawer upsell cards are handled by initUpsell (with list context).
      if (card.closest('.cart-upsell')) return;

      var list = window.ga4ListData || {};
      gtag('event', 'select_item', {
        item_list_id: list.list_id || '',
        item_list_name: list.list_name || '',
        items: [{
          item_id: card.dataset.ga4ProductId,
          item_name: card.dataset.ga4ProductName,
          item_brand: card.dataset.ga4ProductVendor,
          item_category: card.dataset.ga4ProductCategory,
          price: parseFloat(card.dataset.ga4ProductPrice) || 0,
          quantity: 1,
        }],
      });
    });
  }

  /* ─── upsell_add_to_cart ─────────────────────────────────
     The app records every add_to_cart; this only flags adds that came from
     the cart-drawer upsell (an upsell Add button was clicked for this variant
     moments ago), as a separate event so they aren't counted twice.
     product-form.js publishes 'cart-update' after a successful cart add.
  ─────────────────────────────────────────────────────────*/
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (eventData) {
    if (eventData.source !== 'product-form') return;
    if (
      !pendingUpsellVariant ||
      String(pendingUpsellVariant.id) !== String(eventData.productVariantId) ||
      Date.now() - pendingUpsellVariant.ts >= 5000
    ) return;
    pendingUpsellVariant = null;

    var cart = eventData.cartData;
    if (!cart || !cart.items) return;
    var variantId = parseInt(eventData.productVariantId, 10);
    var item = cart.items.find(function (i) { return i.variant_id === variantId; });
    if (!item) return;

    gtag('event', 'upsell_add_to_cart', {
      currency: cart.currency,
      value: item.price / 100,
      items: [{
        item_id: String(item.product_id),
        item_name: item.product_title,
        item_brand: item.vendor,
        item_category: item.product_type,
        item_variant: item.variant_title !== 'Default Title' ? item.variant_title : undefined,
        item_list_id: UPSELL_LIST.id,
        item_list_name: UPSELL_LIST.name,
        price: item.price / 100,
        quantity: 1,
      }],
    });
  });

  /* ─── cart-drawer upsell funnel ──────────────────────────
     Impression when the injected cards appear, select_item on a
     card-link click, and a pending-variant flag so the
     upsell_add_to_cart subscriber above can pick the add up.
  ─────────────────────────────────────────────────────────*/
  function buildUpsellItem(li, index) {
    return {
      item_id: li.dataset.ga4ProductId,
      item_name: li.dataset.ga4ProductName,
      item_brand: li.dataset.ga4ProductVendor,
      item_category: li.dataset.ga4ProductCategory,
      price: parseFloat(li.dataset.ga4ProductPrice) || 0,
      index: index,
      item_list_id: UPSELL_LIST.id,
      item_list_name: UPSELL_LIST.name,
      quantity: 1,
    };
  }

  function trackUpsellImpression(list) {
    if (!list || list.__ga4Tracked) return;
    var items = Array.prototype.map.call(
      list.querySelectorAll('.cart-upsell__item'),
      buildUpsellItem
    );
    if (!items.length) return;
    list.__ga4Tracked = true;
    gtag('event', 'view_item_list', {
      item_list_id: UPSELL_LIST.id,
      item_list_name: UPSELL_LIST.name,
      items: items,
    });
  }

  function initUpsell() {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (node) {
          if (node.nodeType !== 1 || !node.querySelector) return;
          var list =
            (node.matches('.cart-upsell__list') && node) ||
            node.querySelector('.cart-upsell__list');
          if (list) trackUpsellImpression(list);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', function (e) {
      var li = e.target.closest('.cart-upsell__item');
      if (!li) return;
      if (e.target.closest('a[href*="/products/"]')) {
        gtag('event', 'select_item', {
          item_list_id: UPSELL_LIST.id,
          item_list_name: UPSELL_LIST.name,
          items: [buildUpsellItem(li, 0)],
        });
      }
      if (e.target.closest('.cart-upsell__add')) {
        var input = li.querySelector('[name="id"]');
        if (input) pendingUpsellVariant = { id: input.value, ts: Date.now() };
      }
    });
  }

  /* ─── init ───────────────────────────────────────────────*/
  document.addEventListener('DOMContentLoaded', function () {
    trackViewItemList();
    initSelectItem();
    initUpsell();
  });
})();
